import { getStreamTokenDirect } from '@simplywallst/services';
import { withAuth } from '@utilities/queries';

type StreamTokenResponse = Awaited<
  ReturnType<typeof getStreamTokenDirect>
>['data'];

export default async function streamQueryDirect(): Promise<
  StreamTokenResponse | undefined
> {
  const response = await withAuth(getStreamTokenDirect);
  return response.data;
}
